import { useShareRangeAnalysisEventsQuery } from "src/store/shareRangeAnalysisEvent";
import { useLocationAnalysisEventsQuery } from "src/store/locationAnalysisEvent";

export function useShareRangeAnalysisCounts() {
  const { data: pendingApproval } = useShareRangeAnalysisEventsQuery({
    tab: "pending_approval",
    limit: 1,
  });
  const { data: pendingDelivery } = useShareRangeAnalysisEventsQuery({
    tab: "pending_delivery",
    limit: 1,
  });
  const { data: recentlyDelivered } = useShareRangeAnalysisEventsQuery({
    tab: "recently_delivered",
    limit: 1,
  });

  return {
    pendingApproval: pendingApproval?.count ?? 0,
    pendingDelivery: pendingDelivery?.count ?? 0,
    recentlyDelivered: recentlyDelivered?.count ?? 0,
  };
}

export function useLocationAnalysisCounts() {
  const { data: pendingApproval } = useLocationAnalysisEventsQuery({
    tab: "pending_approval",
    limit: 1,
  });
  const { data: pendingDelivery } = useLocationAnalysisEventsQuery({
    tab: "pending_delivery",
    limit: 1,
  });
  const { data: recentlyDelivered } = useLocationAnalysisEventsQuery({
    tab: "recently_delivered",
    limit: 1,
  });

  return {
    pendingApproval: pendingApproval?.count ?? 0,
    pendingDelivery: pendingDelivery?.count ?? 0,
    recentlyDelivered: recentlyDelivered?.count ?? 0,
  };
}
